<template>
  <div>
    <a class="btn btn-clear" href="#" @click.prevent="goBack()">
      <div class="grid-x align-middle" style="line-height:1">
        <div class="cell shrink">
          <span v-html="$icons.get('circle_arrow_left', 'large')" style="margin-right:.3rem"></span>
        </div>
        <div class="cell auto">
          {{ label }}
        </div>
      </div>
    </a>
  </div>
</template>

<script>
export default { 
  name: 'BackLink',
  methods: {
    goBack () {
      if (!this.hasBack) {
        this.$commit.status('dir_entry', true)
      }
      this.$router.push('/providers')
    }
  },
  computed: {
    hasBack () {
      return this.$store.status.dir_entry
    },
    label () {
      return (this.hasBack ? 'Back' : 'Go') + ' to provider directory'
    }
  }
}
</script>
